module.exports = __webpack_public_path__ + "static/media/menu-item-placeholder.54479893.svg";